import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import CartBody from "./CartBody/CartBody";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import PaypalLogo from "../../../../Assets/Images//paypal.png";

import { useStyles } from "./MobileCart.css";
import CustomDialogBox from "../../../../Component/CustomDialogBox/CustomDialogBox";
import CustomerKhaltiPay from "../../../../Component/KhaltiPay/CustomerKhaltiPay";

class MobileCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      checkoutStatus: false,
    };
  }

  handleDialogOpen = () => {
    this.setState({
      dialogOpen: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleClear = async () => {
    this.props.clearCart();
    this.handleDialogClose();
  };

  handleCheckoutStatus = () => {
    this.setState({ checkoutStatus: true });
  };

  handleCancelCheckoutStatus = () => {
    this.setState({ checkoutStatus: false });
  };

  render() {
    const { classes, cart, deleteFromCart } = this.props;
    return this.state.checkoutStatus === false ? (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ flexGrow: 1, fontSize: 20, fontWeight: "bold" }}>
            My Cart ({cart.length})
          </div>
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            onClick={this.handleDialogOpen}
          >
            Clear Cart
          </Button>
        </div>
        <br />

        {cart.length !== 0 ? (
          <Grid container spacing={3}>
            {cart.map((item, index) => (
              <Grid item xs={12} sm={12} md={12} key={index}>
                <CartBody item={item.id} deleteFromCart={deleteFromCart} />
              </Grid>
            ))}
            <Paper
              elevation={0}
              style={{
                width: "100%",
                position: "fixed",
                bottom: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <b style={{ paddingRight: 10 }}>
                Total Price: Rs. {this.props.totalPrice} /-
              </b>
              <Button
                className={classes.buttonStyle}
                style={{ fontSize: 16 }}
                onClick={() => this.handleCheckoutStatus()}
              >
                Checkout
              </Button>
            </Paper>
          </Grid>
        ) : (
          <div>Cart is Empty</div>
        )}

        <CustomDialogBox
          question="Are you sure you want to clear the cart?"
          description="Click clear button to clear the cart"
          buttonLabel="Clear"
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleCancel}
        />
      </div>
    ) : (
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ flexGrow: 1, fontSize: 20, fontWeight: "bold" }}>
            Checkout
          </div>
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            onClick={this.handleCancelCheckoutStatus}
          >
            Cancel
          </Button>
        </div>
        <div>Total Item: Rs. {this.props.cart.length}</div>
        <div>Total Price: {this.props.totalPrice}</div>

        {this.props.isAuth === true && this.props.emailVerified === true ? (
          <div>
            <p style={{ fontSize: 24 }}>Pay with</p>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <CustomerKhaltiPay
                classes={classes.buttonStyle}
                payType="khalti"
                productIdentity={this.props.orderId}
                productName={`Cart-${this.props.orderId}`}
                // productUrl={`http://localhost:3000/books`}
                productUrl={`https://bookashram.netlify.app/books`}
                itemDetails={this.props.cart}
                total={this.props.totalPrice}
                userToken={this.props.userToken}
                reloadUrl={`/cart`}
                clearCart={this.clearCart}
              />
              <Button
                className={classes.buttonStyle}
                onClick={() => this.props.handleDialogOpen("paypal")}
              >
                <img
                  src={PaypalLogo}
                  alt="paypal"
                  style={{ width: 150, height: 70 }}
                />
              </Button>
            </div>
          </div>
        ) : (
          <div>
            You need to first verify your email address in order to complete
            transaction.
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.isAuth,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(MobileCart)));
